import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import WelcomeImage from "../../components/WelcomeImage";
import ImageText1 from "../../components/ImageText1";
import ImageText2 from "../../components/ImageText2";
import Footer from "../../components/Footer";
import backgroundImage from "../../assets/images/overige/bg-overige.jpg";
import imageUrl1 from "../../assets/images/overige/overige-section1.jpg";
import imageUrl2 from "../../assets/images/overige/overige-section2.jpg";
import imageUrl3 from "../../assets/images/overige/overige-section3.jpg";
import imageUrl4 from "../../assets/images/overige/overige-section4.jpg";

import partner1 from "../../assets/images/partners/logo1.jpg";
import partner2 from "../../assets/images/partners/logo2.jpeg";
import partner3 from "../../assets/images/partners/logo3.jpg";
import partner4 from "../../assets/images/partners/logo4.png";
import partner5 from "../../assets/images/partners/logo5.jpg";
import partner6 from "../../assets/images/partners/logo6.png";
import LogosSlider from "../../components/Slider";

const clientLogos = [
  {
    src: partner1,
    alt: "albelli",
  },
  {
    src: partner2,
    alt: "bol",
  },
  {
    src: partner3,
    alt: "dd-group",
  },
  {
    src: partner4,
    alt: "Hi-Tech",
  },
  {
    src: partner5,
    alt: "jumbo-sports",
  },
  {
    src: partner6,
    alt: "kent",
  },
];

function OverigeDiensten() {
  const welcomeHeading = "Overige Diensten";

  //   const imageTextHeading =
  //     "De kracht van de juiste medewerker op de juiste plek!";
  const imageTextText = (
    <>
      {/* <span style={{ fontWeight: "bold" }}>
        Ons werving- en selectieproces is transparant en flexibel. Directe werving- en selectie, of in combinatie met een voorafgaande detacheringsperiode, alles is mogelijk.
      </span> */}
      Naast onze inhouse expertise en de diensten die wij zelf leveren bieden
      wij de volgende additionele diensten in samenwerking met partners aan:{" "}
      <br /> <br />
      <h2>
        <strong>Health, Safety & Environment</strong>
      </h2>
      Ruime expertise op het gebied van veiligheidskunde, arbo en milieu. Het
      ondersteunen van organisaties in het beheersen van risico’s en het naleven
      van wet- en regelgeving op dit gebied. Denk hierbij aan
      Risico-Inventarisatie & Evaluatie (RI&E), het begeleiden van
      bodemsaneringen en het verbeteren van de arbeidsomstandigheden. Hiermee
      bouwen we aan een toekomstbestendige organisatie waar veiligheid,
      gezondheid en duurzaamheid centraal staan.
    </>
  );

  const imageTextText2 = (
    <>
      <h2>
        <strong>Commissioning</strong>
      </h2>
      Commissioning is het proces waarin gecontroleerd wordt dat alle systemen
      en componenten van een gebouw of industriële installatie ontworpen,
      geïnstalleerd, getest, bediend en onderhouden worden zoals het in het
      programma van eisen omschreven is. Dit gebeurt middels het ontwerpen,
      documenteren en inplannen van een commissioningsplan. Het uitvoeren van
      testen, het kalibreren en keuren van technische installaties maken hier
      onderdeel van uit.
    </>
  );
  const imageTextText4 = (
    <>
      <h2>
        <strong>IT (Cyber) Security en Testing</strong>
      </h2>
      Het creëren van een veilige digitale omgeving voor organisaties, mensen en
      softwaresystemen. De focus ligt op informatiebeveiligingsmanagement,
      risicobeheer en compliance. Er wordt voor gezorgd dat systemen goed worden
      onderhouden, voldoen aan functionele vereisten en optimale
      gebruikerservaringen bieden. Door ‘best practices’ voor softwarekwaliteit
      en security te integreren in het ontwikkel- en testproces, wordt robuuste,
      veilige software gebouwd.
    </>
  );
  const imageTextText3 = (
    <>
      <h2>
        <strong>Trainingen</strong>
      </h2>
      Het bieden van betaalbare trainingen op het gebied van solliciteren,
      financiële planning, gespreksvaardigheden en supply chain. <br /> <br />
      <h2>
        <strong>Game-based learning</strong>
      </h2>
      Een platform voor game-based learning met behulp van simulatiespellen.{" "}
      <br /> <br />
      <h2>
        <strong>IT Solutions Supply Chain</strong>
      </h2>
      Het stroomlijnen van de supply chain met behulp van een GAP-analyse en op
      maat gemaakte IT-oplossingen. Op basis van deze inzichten wordt een
      projectkader ontworpen, waarbij gezorgd wordt voor praktische resultaten
      en duidelijke tijdlijnen.
    </>
  );

  return (
    <div>
      <Helmet>
        <title>Overige Diensten</title>
        <meta
          name="description"
          content="Ontdek beter leren met DD-Group en Play-IT! Onze op games gebaseerde trainingen maken leren leuk en effectief. Neem contact met ons op om Play-IT te verbinden voor op maat gemaakte trainingsoplossingen die aan je behoeften voldoen."
        />
      </Helmet>
      <header>
        <Header />
      </header>
      <main>
        <WelcomeImage
          backgroundImage={backgroundImage}
          heading={welcomeHeading}
        />
        <section>
          <ImageText1
            imageUrl={imageUrl1}
            // heading={imageTextHeading}
            text={imageTextText}
          />
          <ImageText2
            imageUrl={imageUrl2}
            text={imageTextText2}
            backgroundColor="#D9D9D9"
            textColor="black"
          />
          <ImageText1
            imageUrl={imageUrl3}
            // heading={imageTextHeading}
            text={imageTextText3}
          />
          <ImageText2
            imageUrl={imageUrl4}
            text={imageTextText4}
            backgroundColor="#D9D9D9"
            textColor="black"
          />
          <LogosSlider images={clientLogos} />
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default OverigeDiensten;
